import { MARQUEE_ITEMS } from "../data/content";

export default function Marquee() {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];

  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-obsidian py-4"
    >
      <div className="flex w-max animate-marquee">
        {row.map((item, i) => (
          <span
            key={`${item}-${i}`}
            className="flex items-center text-xs font-mono uppercase tracking-[0.3em] text-stone-400"
          >
            <span className="px-8">{item}</span>
            <span className="text-gold">•</span>
          </span>
        ))}
      </div>
    </div>
  );
}
